import React, { useState, useRef } from 'react';
import { createPortal } from 'react-dom';
import { uploadsAPI } from '../services/api';
import ZoomGallery, { isTouch } from './ZoomGallery';
import { getRecentVehicles, pushRecentVehicle, clearRecentVehicles } from '../services/recentVehiclesStore';

const PREVIEW = 250;

// Small vehicle model thumbnail; hover shows a floating preview (desktop), tap opens a pinch-zoom gallery (touch)
const ModelThumb = ({ src, alt, size = 40, className = '', testId, gallery, shareUrl }) => {
  const ref = useRef(null);
  const [pos, setPos] = useState(null);
  const [items, setItems] = useState(null);
  const openZoom = () => {
    const base = gallery?.length ? gallery : [{ src, alt, url: shareUrl }];
    const recent = getRecentVehicles().filter((r) => !base.some((b) => b.src === r.src)).map((r) => ({ ...r, recent: true }));
    setItems([...base, ...recent]);
  };
  if (!src) return null;
  const url = uploadsAPI.resolveUrl(src);
  const show = () => {
    if (isTouch()) return;
    const r = ref.current?.getBoundingClientRect();
    if (!r) return;
    const pad = 12;
    let left = r.right + pad;
    if (left + PREVIEW + 24 > window.innerWidth) left = r.left - PREVIEW - 24 - pad;
    let top = r.top + r.height / 2 - (PREVIEW + 44) / 2;
    top = Math.max(8, Math.min(top, window.innerHeight - PREVIEW - 52));
    setPos({ left: Math.max(8, left), top });
  };
  const onTap = (e) => {
    if (!isTouch()) return;
    e.preventDefault();
    e.stopPropagation();
    items ? setItems(null) : openZoom();
  };
  const index = items ? Math.max(0, items.findIndex((g) => g.src === src)) : 0;
  return (
    <>
      <img ref={ref} src={url} alt={alt || ''} loading="lazy" width={size} height={size} onMouseEnter={show} onMouseLeave={() => setPos(null)} onFocus={show} onBlur={() => setPos(null)} onClick={onTap}
        className={`no-placeholder object-contain shrink-0 cursor-zoom-in transition-transform duration-200 hover:scale-110 ${className}`} style={{ width: size, height: size }} data-testid={testId} />
      {pos && createPortal(
        <div style={{ position: 'fixed', left: pos.left, top: pos.top, zIndex: 9999 }} className="pointer-events-none rounded-xl border border-gray-200 bg-white shadow-2xl p-3 animate-in fade-in zoom-in-95 duration-150" data-testid={testId ? `${testId}-preview` : undefined}>
          <img src={url} alt={alt || ''} width={PREVIEW} height={PREVIEW} className="no-placeholder object-contain bg-white rounded-lg" style={{ width: PREVIEW, height: PREVIEW }} />
          {alt && <p className="mt-2 text-center text-xs font-semibold text-gray-800 truncate" style={{ maxWidth: PREVIEW }}>{alt}</p>}
        </div>, document.body)}
      {items && <ZoomGallery items={items} index={index} onIndexChange={(i) => items[i]?.url && pushRecentVehicle(items[i])} onClearRecent={() => { clearRecentVehicles(); setItems(items.filter((i) => !i.recent)); }} onClose={() => setItems(null)} testId={testId} />}
    </>
  );
};

export default ModelThumb;
